<template>
   <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    data(){
        return{
        }   
    },
    mounted(){
    },
    methods:{
    }
}
</script>

<style>
@import "common/css/publicclass.css";
</style>
